import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import NewsBox from './newsBox';
import Slide from './slide';
import VideoBox from './videoBox';

class News extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { newsBoxData, slideData, videoBoxData, newsAndVideoAd0, newsAndVideoAd1, newsAndVideoAd2 },
        } = this.props;

        return (
            <div className={styles.news}>
                <div className="clearfix">
                    <NewsBox content={newsBoxData} />
                    <div className={styles.news_R}>
                        <Slide content={slideData} />
                        <VideoBox content={videoBoxData} />
                    </div>
                </div>
                <div className={styles.ad_box}>
                    <NoSSR>
                        <Ad content={newsAndVideoAd0} styleName={styles.fl} />
                    </NoSSR>
                    <NoSSR>
                        <Ad content={newsAndVideoAd1} styleName={styles.fr} />
                    </NoSSR>
                </div>
                {newsAndVideoAd2 ? <Ad content={newsAndVideoAd2} styleName={styles.ad} /> : ''}
            </div>
        );
    }
}

export default errorBoundary(News);
